import { graphql, useStaticQuery } from "gatsby";
import { useMemo } from "react";
import { ArrayElement } from "@src/interface/utils";
import usePageLang from "../usePageLang";

export type IngredientItem = ArrayElement<
  Queries.UseAllIngredientQuery["allIngredient"]["nodes"]
>;

const useAllIngredient = (
  filter?: {
    lang?: string;
    id_ingredient?: string;
    in_glossary?: boolean;
  },
  predicate?: (ingredient: IngredientItem) => boolean
): IngredientItem[] => {
  const currentLang = usePageLang();

  const { allIngredient } =
    useStaticQuery<Queries.UseAllIngredientQuery>(graphql`
      query UseAllIngredient {
        allIngredient(sort: { name: ASC }) {
          nodes {
            id_ingredient
            in_glossary
            lang
            name
            description
            relatedProducts {
              id_product
              name
              uri
              is_travel_retail
            }
          }
        }
      }
    `);

  const data = useMemo(() => {
    const nodes = allIngredient.nodes.filter(
      (node) => node.lang === currentLang
    );
    if (!filter && !predicate) {
      return nodes;
    }
    return nodes.filter((ingredient) => {
      let matchFilter = true;
      Object.entries(filter || {}).forEach(([k, v]) => {
        if (v && ingredient[k as keyof typeof ingredient] !== v) {
          matchFilter = false;
        }
      });
      return matchFilter && (predicate ? predicate(ingredient) : true);
    });
  }, [allIngredient, currentLang, filter, predicate]);

  return data;
};

export default useAllIngredient;
